import { createRef } from 'react';
import { useHistory } from 'react-router-dom';

export const historyRef = createRef<ReturnType<typeof useHistory>>();
